import FormToggle from "root/ReactHookForm/ui/FormToggle";
import './ToggleIncludeLunch.scss';
const ToggleIncludeLunch = ({control, name, onChange, rules, placeholder, isSearchable, isClearable, isMulti, readOnly}) =>
{

    return (
        <div className='toggle-inlcude-lunch'>
            <FormToggle control={control} name={name} readOnly={readOnly}/>
        </div>
    )
}

export default ToggleIncludeLunch;